import React, { useCallback } from 'react';
import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';

import refreshIcon from '@ingka/ssr-icon/paths/arrow-clockwise';
import { useParentItemsFromSelectedSubItems } from '../../state/selection.state';
import { useRefreshMutation } from '../../hooks/useRefreshMutation';

export const RefreshConnectedButton = (): JSX.Element => {
   const selectedItems = useParentItemsFromSelectedSubItems(true);
   const { mutate, isProcessing } = useRefreshMutation('refresh');

   const onClick = useCallback(() => {
      mutate(selectedItems);
   }, [selectedItems, mutate]);

   return (
      <StyledTooltip title="Refresh items from PIA">
         <span>
            <StyledToolbarButton
               ssrIcon={refreshIcon}
               text="Refresh"
               iconOnly={true}
               small={true}
               onClick={onClick}
               disabled={selectedItems.length === 0 || isProcessing}
            />
         </span>
      </StyledTooltip>
   );
};